import React from 'react'

import { shape, string } from 'prop-types'

import quoteImage from 'images/discover/business_account/quote.svg'

function Quote({ quote }) {
  return (
    <section className="business-account-quote">
      <figure className="discover-container business-account-quote__wrap">
        <img src={quoteImage} alt="" width={36} height={32} loading="lazy" />
        <blockquote className="business-account-quote__text">{quote.text}</blockquote>
        <figcaption className="business-account-quote__author cgt-body-lg">
          <span className="business-account-quote__name">{quote.author}</span>
          <span className="business-account-quote__divider" aria-hidden="true" />
          <span>{quote.company}</span>
        </figcaption>
      </figure>
    </section>
  )
}

Quote.propTypes = {
  quote: shape({
    text: string.isRequired,
    author: string.isRequired,
    company: string.isRequired,
  }).isRequired,
}

export default Quote
